'use client';

import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { AnimatePresence } from 'motion/react';
import NavigationMobile from '../navigation-mobile/NavigationMobile';
import NavigationDesktop from '../navigation-desktop/NavigationDesktop';
import Search from './Search';

// Single entry point for the site navigation. The mobile (burger) and desktop
// navs both render from the same `block` — one menu query, one transform — and
// each is shown/hidden by its own breakpoint styles. The search overlay lives
// here so it can be opened from either nav.
export default function NavigationMain({ block }) {
  const router = useRouter();
  const [searchOpen, setSearchOpen] = useState(false);
  const openSearch = () => setSearchOpen(true);

  // Close the search overlay whenever the route changes.
  useEffect(() => {
    const handleRouteChange = () => setSearchOpen(false);
    router.events.on('routeChangeStart', handleRouteChange);
    return () => router.events.off('routeChangeStart', handleRouteChange);
  }, [router.events]);

  // Guard sits below every hook so the hook order is identical on every render.
  if (!block || !block.menuItems) return null;

  return (
    <>
      <NavigationMobile block={block} onOpenSearch={openSearch} />
      <NavigationDesktop block={block} onOpenSearch={openSearch} />

      <AnimatePresence>
        {searchOpen && (
          <Search
            key="nav-search"
            isOpen={searchOpen}
            onClose={() => setSearchOpen(false)}
          />
        )}
      </AnimatePresence>
    </>
  );
}
